<template>
  <v-card class="ma-2 beez-card" :key="taskId + '-task-detail'">
    <v-toolbar dense flat>
      Task Details
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on: menu }">
          <v-btn
            flat
            icon
            v-on="{ ...menu }"
            :disabled="
              !(task.candidateEmailList && task.candidateEmailList.length > 0)
            "
          >
            <v-icon>people</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in task.candidateEmailList"
            :key="index"
          >
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <task-comments v-show="!taskFormLoader" :task-hex-id="task.hexId" />
    </v-toolbar>
    <v-expansion-panel expand v-model="taskDetailsPanel">
      <v-expansion-panel-content
        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
      >
        <template slot="header">
          <div class="body-2">
            <v-icon class="pr-3">mdi-page-layout-header</v-icon>
            Technical Details
          </div>
        </template>
        <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
          <v-card-text>
            <v-layout class="row wrap">
              <v-flex d-flex xs12 class="beez-padding">
                <v-card style="border-radius: 10px" flat>
                  <v-flex xs12 class="beez-padding">
                    <v-layout row wrap class="beez-padding">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Task Identifier</div>
                              <div class="subheading">{{ task.taskId }}</div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Form Key</div>
                              <div class="subheading">
                                {{ task.formKey }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Name</div>
                              <div class="subheading">
                                {{ task.name }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Description</div>
                              <div class="subheading">
                                {{ task.description }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Owner</div>
                              <div class="subheading">
                                {{ task.owner }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Created At</div>
                              <div class="subheading">
                                {{ task.createdAtLocal }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Priority</div>
                              <div class="subheading">
                                {{ task.priority }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                          <v-flex xs12 md6 lg4>
                            <div class="text-xs-left">
                              <br />
                              <div>Requested by</div>
                              <div class="subheading">
                                {{ task.externalRequestedBy }}
                              </div>
                              <br />
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="task.workflowId">
                          <v-flex xs12 fill-height>
                            <v-layout row wrap>
                              <v-flex xs12 md6>
                                <v-layout row wrap>
                                  <v-flex xs8>
                                    <div class="text-xs-left">
                                      <br />
                                      <div>
                                        Workflow Identifier
                                      </div>
                                      <div class="subheading">
                                        {{ task.workflowId }}
                                      </div>
                                      <br />
                                    </div>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-btn
                                      :outline="$vuetify.dark"
                                      icon
                                      class="ma-4"
                                      flat
                                      @click="openWorkflow(task.workflowId)"
                                    >
                                      <v-icon>link</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs12 md6>
                                <v-layout row wrap>
                                  <v-flex xs8>
                                    <div class="text-xs-left">
                                      <br />
                                      <div>
                                        Execution Identifier
                                      </div>
                                      <div class="subheading">
                                        {{ task.tulipExecutionId }}
                                      </div>
                                      <br />
                                    </div>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-btn
                                      :outline="$vuetify.dark"
                                      icon
                                      flat
                                      class="ma-4"
                                      @click="
                                        openExecution(task.tulipExecutionId)
                                      "
                                    >
                                      <v-icon>link</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex d-flex xs12 md6 lg4>
                            <v-layout row wrap>
                              <v-flex xs2>
                                <v-avatar tile>
                                  <v-icon class="secondary--text" medium
                                    >notification_important
                                  </v-icon>
                                </v-avatar>
                              </v-flex>
                              <v-flex xs6>
                                <div class="text-xs-left">
                                  <div>Set Due date</div>
                                  <div class="subheading">
                                    {{ delta.dueDate || task.dueLocal }}
                                  </div>
                                </div>
                              </v-flex>
                              <v-flex xs4>
                                <div
                                  class="text-xs-left"
                                  v-if="update.dueDateChange"
                                >
                                  <v-btn
                                    flat
                                    icon
                                    @click="update.dueDateChange = false"
                                    v-if="
                                      can('TASK_EDIT_DUE_DATE') &&
                                        !task.completedAt
                                    "
                                  >
                                    <v-icon>
                                      edit
                                    </v-icon>
                                  </v-btn>
                                </div>
                                <div class="text-xs-left" v-else>
                                  <v-layout row wrap>
                                    <v-flex xs4>
                                      <date-time-picker
                                        @submit="setDueDate"
                                      ></date-time-picker>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="updateTask(task)"
                                      >
                                        <v-icon>
                                          save
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="
                                          delta.dueDate = null
                                          update.dueDateChange = true
                                        "
                                      >
                                        <v-icon>
                                          clear
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex d-flex xs12 md6 lg4>
                            <v-layout row wrap>
                              <v-flex xs2>
                                <v-avatar tile>
                                  <v-icon class="secondary--text" medium
                                    >event
                                  </v-icon>
                                </v-avatar>
                              </v-flex>
                              <v-flex xs6>
                                <div class="text-xs-left">
                                  <div>Set follow-up date</div>
                                  <div class="subheading">
                                    {{
                                      delta.followupDate || task.followUpLocal
                                    }}
                                  </div>
                                </div>
                              </v-flex>
                              <v-flex xs4>
                                <div
                                  class="text-xs-left"
                                  v-if="update.followUpDateChange"
                                >
                                  <v-btn
                                    flat
                                    icon
                                    @click="update.followUpDateChange = false"
                                    v-if="
                                      can('TASK_DATE_FOLLOWUP') &&
                                        !task.completedAt
                                    "
                                  >
                                    <v-icon>
                                      edit
                                    </v-icon>
                                  </v-btn>
                                </div>
                                <div class="text-xs-left" v-else>
                                  <v-layout row wrap>
                                    <v-flex xs4>
                                      <date-time-picker
                                        @submit="setFollowUpDate"
                                      ></date-time-picker>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="updateTask(task)"
                                      >
                                        <v-icon>
                                          save
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-btn
                                        flat
                                        icon
                                        @click="
                                          delta.followupDate = null
                                          update.followUpDateChange = true
                                        "
                                      >
                                        <v-icon>
                                          clear
                                        </v-icon>
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--        Task Form -->
    <div>
      <div>
        <v-progress-linear
          color="accent"
          :indeterminate="true"
          v-if="taskFormLoader"
        ></v-progress-linear>
        <div
          v-if="
            task.taskForm &&
              Array.isArray(task.taskForm) &&
              task.taskForm.length > 0
          "
        >
          <v-flex xs12>
            <proposal-renderer :proposals="task.taskForm" :readonly="true">
            </proposal-renderer>
          </v-flex>
        </div>
        <v-card
          flat
          v-else
          style="border-radius: 0px 0px 10px 10px"
          class="pa-3"
        >
          <v-alert
            style="border-radius: 10px"
            :value="true"
            color="info"
            icon="info"
            outline
          >
            Task form not available for this task</v-alert
          >
        </v-card>
      </div>
    </div>
  </v-card>
</template>

<script>
import DateTimePicker from '../common/DateTimePicker'
import ProposalRenderer from '@/components/common/ProposalRenderer'
import TaskComments from '@/components/task-lists/TaskComments'
import moment from 'moment'
import u from '@/utils'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'TaskDetail',
  components: { ProposalRenderer, DateTimePicker, TaskComments },
  props: {
    taskId: String
  },
  data: () => {
    return {
      taskDetailsPanel: [false],
      taskFormLoader: false,
      update: {
        dueDateChange: true,
        followUpDateChange: true
      },
      delta: {
        dueDate: null,
        followupDate: null
      }
    }
  },
  computed: {
    ...mapState({
      task: state => state.tasks.task
    }),
    ...mapGetters({
      can: 'can'
    })
  },
  watch: {
    taskId() {
      this.getTaskFormDetails()
    }
  },
  mounted() {
    this.getTaskFormDetails()
  },
  methods: {
    async getTaskFormDetails() {
      this.taskFormLoader = true
      try {
        await this.$store.dispatch('getTaskFormDetails', {
          id: this.taskId
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to get Task Details!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskFormLoader = false
    },
    setFollowUpDate(dateTime) {
      this.delta.followupDate = moment(dateTime).format(
        'MMMM Do YYYY, h:mm:ss a'
      )
    },
    setDueDate(dateTime) {
      this.delta.dueDate = moment(dateTime).format('MMMM Do YYYY, h:mm:ss a')
    },
    async updateTask(item) {
      let localItem = {}
      localItem.id = item.taskId
      if (this.delta.dueDate) {
        localItem.due = moment(
          this.delta.dueDate,
          'MMMM Do YYYY, h:mm:ss a'
        ).format('YYYY-MM-DDTHH:mm:ss.SSSZZ')
      }
      if (this.delta.followupDate) {
        localItem.followUp = moment(
          this.delta.followupDate,
          'MMMM Do YYYY, h:mm:ss a'
        ).format('YYYY-MM-DDTHH:mm:ss.SSSZZ')
      }
      try {
        await this.$store.dispatch('saveTask', localItem)
        this.delta.dueDate = null
        this.delta.followupDate = null
        this.update.dueDateChange = true
        this.update.followUpDateChange = true
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Task has been Saved',
          description: 'User Task saved Successfully',
          type: 'success'
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Cannot update task!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }

      try {
        await this.$store.dispatch('replicateTask', item.hexId)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Cannot replicate task!',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      await this.getTaskFormDetails()
    },
    openWorkflow(workflowId) {
      this.$router
        .push({
          name: 'workflow-detail',
          params: { hexId: workflowId }
        })
        .catch()
    },
    openExecution(executionId) {
      this.$router
        .push({ name: 'executions', query: { search: executionId } })
        .catch()
    }
  }
}
</script>

<style scoped></style>
